
export default function FactoryHeroSection() {
  return (
    <section id="hero" className="relative min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-800 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/457ccb5806f1fa16f4ac9ce6c83b0534.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-black/60" />
      
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto pt-20">
        <div className="space-y-8">
          <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white leading-tight">
            工厂合作计划
            <span className="block text-blue-400 mt-2">携手共建茶叶供应链</span>
          </h1>
          
          <p className="text-base md:text-xl lg:text-2xl text-white/90 leading-relaxed max-w-4xl mx-auto">
            与优质茶叶工厂深度合作，打造稳定可靠的供应链体系<br />
            提供技术支持、品质管控、市场推广全方位合作
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <a href="#application" className="cursor-pointer">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap">
                <i className="ri-handshake-line mr-2"></i>
                申请合作
              </button>
            </a>
            <a href="#advantages" className="cursor-pointer">
              <button className="border-2 border-white text-white hover:bg-white hover:text-gray-800 px-8 py-4 rounded-full font-semibold text-sm md:text-lg transition-all duration-300 cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>
                了解详情
              </button>
            </a>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto mt-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">50+</div>
              <div className="text-white text-sm md:text-base">合作工厂</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">5000吨+</div>
              <div className="text-white text-sm md:text-base">年产能</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">98%</div>
              <div className="text-white text-sm md:text-base">合格率</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
              <div className="text-xl md:text-3xl font-bold text-blue-400 mb-1">15年+</div>
              <div className="text-white text-sm md:text-base">平均合作</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#advantages" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
